import styled from 'styled-components';

export const Container = styled.div`
  background-color: #F4F4F5;
  padding: 15px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  cursor: pointer;
  position: relative;
`;

export const Status = styled.div<{ unread: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #99001B;
  display:  ${({ unread }) => (unread ? 'block' : 'none')};
`;

export const Image = styled.img`
    height: 64px;
    width: 64px;
    overflow: hidden;
    border-radius: 5px;
    object-fit: cover;
    align-self: flex-start;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  flex: 1;
  min-height: 64px;
  gap: 15px;
`;

export const Title = styled.span`
  font-size: 14px;
  line-height: 1.2;
  font-weight: 500;
  color: #27272A;
`;

export const Date = styled.span`
  font-size: 12px;
  line-height: 1.2;
  font-weight: 400;
  color: #52525B;
`;
